export const USER_LOGIN_SUCCESS = '[LOGIN]USER_LOGIN_SUCCESS';
